//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () { return { report: {}, loading: true } },
  created () {
    this.$ajax.get(newApi.statsWeeklyReport).then(res => {
      this.report = res || {}
    }).catch(() => {}).finally(() => { this.loading = false })
  },
  methods: {
    formatDuration (sec) {
      if (!sec) return '0小时'
      return (sec / 3600).toFixed(1) + ' 小时'
    },
    formatAccuracy (v) {
      if (v == null) return 0
      return Number(v).toFixed(1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/stats/weeklyReport.vue